import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { VaultAccountDetailsType } from '@/types/myVaultTypes';

export type AddVaultAccountRailsPayloadType = { rails: string[]; fields: Record<string, string> };

export const addVaultAccountRailsApi = (
  id: string,
  data: AddVaultAccountRailsPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<VaultAccountDetailsType>> => {
  return authApiService.POST(`/my-vault/accounts/${id}/add-rails/`, data, null, options);
};
